import { A11yModule } from '@angular/cdk/a11y';
import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { IconsModule } from '@boldpenguin/emperor-icons';
import { LEGACY_MODE, LegacyModeConfig } from '@boldpenguin/emperor-services';
import { EmperorButtonModule } from '../button';
import { EmperorCardModule } from '../card';
import { EmperorDialogHeaderComponent } from './components/dialog-header/dialog-header.component';
import { DynamicDialogComponent } from './components/dynamic-dialog/dynamic-dialog.component';
import { EmperorDialogComponent } from './dialog.component';
import { EmperorDialogCloseDirective } from './directives/dialog-close.directive';
import { DialogInsertionDirective } from './directives/dialog-insertion.directive';
import { EmperorDialogRefService } from './public-api';

export { EmperorDialogHeaderComponent } from './components/dialog-header/dialog-header.component';
export { EmperorDialogComponent } from './dialog.component';
export { EmperorDialogCloseDirective } from './directives/dialog-close.directive';

@NgModule({
  declarations: [
    EmperorDialogComponent,
    EmperorDialogCloseDirective,
    DynamicDialogComponent,
    DialogInsertionDirective,
    EmperorDialogHeaderComponent,
  ],
  imports: [
    CommonModule,
    EmperorButtonModule,
    EmperorCardModule,
    OverlayModule,
    A11yModule,
    IconsModule,
  ],
  exports: [
    EmperorDialogCloseDirective,
    EmperorDialogComponent,
    EmperorDialogHeaderComponent,
  ],
  providers: [
    {
      provide: LEGACY_MODE,
      useValue: true,
    },
  ],
})
export class EmperorDialogModule {
  static forRoot(
    config?: LegacyModeConfig | undefined,
  ): ModuleWithProviders<EmperorDialogModule> {
    return {
      ngModule: EmperorDialogModule,
      providers: [
        EmperorDialogRefService,
        { provide: LEGACY_MODE, useValue: config?.legacyMode ?? true },
      ],
    };
  }
}
